namespace Areas.Requests.Review {
    "use strict";

    export function initiationSave() {
        const mainForm = $("#ProjectInfoUpdateForm").dxForm("instance");
        const result: any = mainForm.validate();

        if (result.isValid) {
            const newData = appendProjectInfoData(mainForm);
            sendRequest("/Requests/Review/Put", JSON.stringify(newData), "PUT");
        }
    }

    export function releaseHold() {
        alert('not implemented');
    }

    export function requestHold() {
        alert('not implemented');
    }

    export function emailCorpAccount() {
        const mainForm = $("#ProjectInfoUpdateForm").dxForm("instance");
        const keyId: any = mainForm.option("ProjectInfoId");

        const afterSuccessfulCompletion = () => {
            hideButton("EmailCorpAccountButton");
            refreshGrid("EventGrid");
        };

        sendRequest(`/Requests/Review/PlantAccountRequest/${keyId}`, "", "PUT", afterSuccessfulCompletion);
    }

    export function prelimApprove() {
        const mainForm = $("#ProjectInfoUpdateForm").dxForm("instance");
        const keyId: any = mainForm.option("ProjectInfoId");

        sendRequest(`/Requests/Review/PrelimApprove/${keyId}`, "", "PUT");
    }

    export function planningReview() {
        const mainForm = $("#ProjectInfoUpdateForm").dxForm("instance");
        const keyId: any = mainForm.option("ProjectInfoId");

        sendRequest(`/Requests/Review/PlanningReview/${keyId}`, "", "PUT");
    }

    export function approve() {
        const mainForm = $("#ProjectInfoUpdateForm").dxForm("instance");
        const result: any = mainForm.validate();

        if (result.isValid) {
            const newData = appendProjectInfoData(mainForm);
            sendRequest("/Requests/Review/Approve", JSON.stringify(newData), "PUT");
        }
    }

    export function complete() {
        const mainForm = $("#ProjectInfoUpdateForm").dxForm("instance");
        const keyId: any = mainForm.option("ProjectInfoId");

        sendRequest(`/Requests/Review/Complete/${keyId}`, "", "PUT");
    }

    export function initiationReturnToRequestor() {
        const verifyReturn = window.confirm("Are you sure you would like to RETURN this record?");

        if (verifyReturn) {
            const mainForm = $("#ProjectInfoUpdateForm").dxForm("instance");

            const keyId: any = mainForm.option("ProjectInfoId");
            if (keyId != null) {
                sendRequest(`/Requests/Review/ReturnToRequestor/${keyId}`, "", "PUT");
            }
        }        
    }

    function appendProjectInfoData(mainForm: DevExpress.ui.dxForm) : any {
        const rechargeForm = $("#RechargeForm").dxForm("instance");
        const planningForm = $("#PlanningForm").dxForm("instance");
        const accountingForm = $("#AccountingForm").dxForm("instance");

        const newData: any = mainForm.option("formData");
        const rechargeData: any = rechargeForm.option("formData");
        const planningData: any = planningForm.option("formData");
        const accountingData: any = accountingForm.option("formData");

        const iRequestorScopeEditor: any = $('#RequestorScopeEditor').dxHtmlEditor('instance');
        const iRequestorScope = iRequestorScopeEditor.option("value");

        const iScopeEditor: any = $('#ScopeEditor').dxHtmlEditor('instance');
        const iScope = iScopeEditor.option("value");

        newData.RequestorScope = iRequestorScope;
        newData.Scope = iScope;

        newData.IsClientFunded = rechargeData.IsClientFunded;
        newData.FundingNotes = rechargeData.FundingNotes;

        newData.ProjectNumber = accountingData.ProjectNumber;
        newData.ProjectCCNumber = accountingData.ProjectCCNumber;
        newData.DurationStartDate = accountingData.DurationStartDate;
        newData.AccountId = accountingData.AccountId;

        newData.ProjectName = planningData.ProjectName;
        newData.RequestNumber = planningData.RequestNumber;
        newData.ProjectCCType = planningData.ProjectCCType;
        newData.ProjectCCName = planningData.ProjectCCName;
        newData.FundingAmount = planningData.FundingAmount;
        newData.DurationMonths = planningData.DurationMonths;

        return newData;
    }

}